import { UPLOAD_URL } from "../../config/constants";
import { Player } from "react-tuby";
import "react-tuby/css/main.css";

//import default avatar
import { memo } from "react";

function videoPlayer({ data , index}) {
  let url = data?.fileUrl;
  if (index !== null && index !== undefined) {
    url = data.fileUrls
      ? UPLOAD_URL +  data?.fileUrls[index]
      : UPLOAD_URL +  data?.fileUrl;
  }

  return (
    <Player
      pictureInPicture={true}
      keyboardShortcut={{
        pause: true,
        forward: true,
        rewind: true,
        fullScreen: true,
        mute: true,
      }}
     src={[
        {
          quality: "Full HD",
          // url: UPLOADS_URL + '/'+data?.fileUrls[0],
          url: url,
        },
      ]}
      poster={
        data?.vidImage
          ? UPLOAD_URL  + data?.vidImage
          : data.videoThumbnails
          ? UPLOAD_URL  + data?.videoThumbnails[index]
          : UPLOAD_URL + data?.image
      }
      // poster={UPLOAD_URL + "/" + data?.image}
    >
      {(ref, { onPlay, ...others }) => (
        <video
          ref={ref}
          {...others}
          onPlay={(e) => {
            // The library original event
            onPlay && onPlay(e);
          }}
        />
      )}
    </Player>
  );
}

export default memo(videoPlayer);
